<template>
  <div>
    <Header :title="''" />
    <div
      class="boss-admin-container clearfix"
    >
      <sidebar />
      <div class="boss-main-container pega-error-container">
        <div class="boss-main-wrap">
          <div class="grid-container margin-auto text-center">
            <div>
              <span class="font-size-1-3em">
                <div class="">404</div>
                <div>お探しのページは見つかりませんでした。</div>
                <div>アクセスしようとしたページは既に存在しないか</div>
                <div>またはURLが間違っている可能性があります。</div>
              </span>
              <div
                class="boss-more-button margin-top-2"
              >
                <button
                  data-test="dashboard-button"
                  class="float-center boss-button-center boss-button-large"
                  @click="$router.push({ name: 'dashboardTop' })"
                >
                  ダッシュボードに戻る
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'

export default {
  components: {
    Sidebar,
    Header
  }
}
</script>
